// global
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
// stylesheet
import styles from './BackPage.module.scss';

function BackPage(props) {
  const { /* id, loading, */ title, onClick } = props;
  return (
    <header className={styles.backButton}>
      <i className={styles.btnBack} aria-hidden='true'>
        <Icon name='angle left' onClick={onClick}></Icon>
      </i>
      <div className={styles.backTitle}>{title}</div>
    </header>
  );
}

BackPage.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func
};

export default BackPage;
